<template>
    <div class="activity"
         :style="`background-image: url('${absolute_canvas_preview_url}')`"
         :class="`type-${activity.type}`"
         @click="show()">
        <div class="title">
            <h6>{{ activity.name }}</h6>
            <div class="info">Activity</div>
        </div>


        <modal :id="utils.randomId({prefix: 'modal'})"
               :show="true"
               size="xl"
               v-if="show_modal"
               @click.prevent.stop=""
               @close="close()">
            <template #title>
                {{ activity.name }}
            </template>


            <div class="preview-content">
                <div class="row">
                    <div class="col-md-8">
                        <tabs :tabs="tabs" @change="tabChanged" tab-size="lg">
                            <template #tab-content-teacher>

                                <iframe v-if="activity.data?.teacher_file && activity.data?.teacher_file?.mime === 'application/pdf'"
                                        :src="uploads.url( activity.data.teacher_file.url ) + '#toolbar=1'"
                                        frameborder="0"></iframe>
                                <img v-else-if="activity.data?.teacher_file && activity.data?.teacher_file?.preview_url" class="preview-image img-fluid mb-3"
                                     :src="uploads.url( activity.data?.teacher_file?.preview_url, {w: 1024, h: 1024, c: false} )" alt="">

                            </template>
                            <template #tab-content-student>
                                <iframe v-if="activity.data?.file && activity.data?.file?.mime === 'application/pdf'"
                                        :src="uploads.url( activity.data.file.url ) + '#toolbar=1'"
                                        frameborder="0"></iframe>
                                <img v-else-if="preview_url" class="preview-image img-fluid mb-3"
                                     :src="`${preview_url ? uploads.url( preview_url, {w: 1024, h: 1024, c: false} ) : 'https://via.placeholder.com/240x240?text=PREVIEW+NOT+AVAILABLE'}`" alt="">
                            </template>
                        </tabs>
                    </div>
                    <div class="col-md-4">

                        <div class="text">

                            <markdown-text :content="activity.data.description" />

                            <template v-if="activity?.data?.type === 'link' && activity?.data?.url">
                                <h5>External Link</h5>
                                <a target="_blank" :href="activity?.data?.url">
                                    {{ utils.ellipsis(activity?.data?.url) }}
                                </a>
                            </template>

                            <template v-if="activity?.data?.teacher_instructions">
                                <h5>Instructions</h5>
                                <markdown-text :content="activity.data.teacher_instructions" />
                            </template>
                        </div>

                    </div>
                </div>
            </div>

            <template #footer v-if="activity.data.file">
                <!--button v-if="editable"
                        type="button"
                        @click="remove()"
                        class="btn btn-danger mr-auto">Remove</button-->
                <a v-if="activity.data.file"
                   :href="download_url"
                   target="_blank"
                   type="button"
                   class="btn btn-success">Download</a>
            </template>
        </modal>
    </div>
</template>

<script>
import utils from "@/mixins/utils";
import Modal from "@/Components/Common/Modal";
import uploads from "@/mixins/uploads";
import MarkdownText from "@/Components/Common/MarkdownText";
import Tabs from "@/Components/Tabs";

export default {
    name: "Activity",
    // props: ['activity', 'editable', 'preview'],
    props: {
        activity: {
            type: Object,
            default: () => null,
        },
        editable: {
            type: Boolean,
            default: false,
        },
        showPreview: {
            type: Boolean,
            default: true,
        }
    },
    emits: ['remove-activity'],
    components: {Tabs, Modal, MarkdownText},
    mixins: [utils, uploads],

    data(){
        return {
            show_modal: false,
            tab_id: 'student',
            tabs: {
                student: 'Student Worksheet',
            }
        }
    },

    computed: {

        options(){
            return this.activity?.data?.options;
        },

        type(){

        },
        file(){
            return this.activity?.data?.file;
        },

        teacher_file(){
            return this.activity?.data?.teacher_file;
        },

        absolute_canvas_preview_url(){

            let url = 'https://via.placeholder.com/480x480?text=PREVIEW+NOT+AVAILABLE';
            let w = 300;
            let h = 300;

            if( this.options?.width ){
                w = h * parseInt(this.options?.width);
            }

            if( this.preview_url ){
                url = this.uploads.image( this.uploads.url( this.preview_url ), {w, h} );
            }

            return url;

        },

        preview_url(){
            if( this.activity.data?.preview_url ) return this.activity.data?.preview_url;
            if( this.activity.data?.preview_file?.preview_url ) return this.activity.data?.preview_file?.preview_url;
            if( this.activity.data?.file?.preview_url ) return this.activity.data?.file?.preview_url;
            return null;
        },

        download_url(){
            if( this.tab_id === 'student' ){
                return this.uploads.url( this.file.url );
            }else if( this.tab_id === 'teacher' ){
                return this.uploads.url( this.teacher_file?.url );
            }
        }

    },

    methods: {
        show(){
            if( !this.showPreview ) return;
            this.show_modal = true;
        },
        close(){
            this.show_modal = false;
        },
        remove(){
            if( !confirm('Are you sure to remove this resource?') ) return;
            this.$emit('remove-activity');
            this.show_modal = false;
        },
        tabChanged(tab_id){
            this.tab_id = tab_id;
        }
    },

    beforeMount() {
        if( this.activity?.data?.teacher_file ) {
            this.tabs.teacher = 'Teacher Instruction Document';
        }
    }

}
</script>

<style lang="scss" scoped>
.activity{
    background: #6c7275 no-repeat center / cover;
    border: #FFFFFF solid 2px;
    border-radius: 6px;
    padding: 100% 0 0;
    cursor: pointer;
    width: 100%;
    position: relative;
    box-shadow: 0 2px 8px #00000029;
}

.aw-1{
    .activity{
        padding-top: 100%;
    }
}

.aw-2{
    .activity{
        padding-top: 50%;
    }
}
.aw-3{
    .activity{
        padding-top: 33.333333%;
    }
}
.aw-4{
    .activity{
        padding-top: 25%;
    }
}
.aw-5{
    .activity{
        padding-top: 20%;
    }
}

.title{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    padding: 1rem;

    h6{
        background: rgba(white, 0.7);
        padding: 0.5rem;
        display: inline-block;
        border-radius: 0.3rem;
        color: $dark;
        backdrop-filter: blur(3px);
    }
}

@media (min-width: 650px) and (max-width: 1199px){
    .aw-1{
        .activity{
            padding-top: 0%;
            padding-bottom: 100%;
        }
    }

    .aw-2{
        .activity{
            padding-top: 0%;
            padding-bottom: 50%;
        }
    }
    .aw-3{
        .activity{
            padding-top: 33.333333%;
            padding-bottom: 33.333333%;
        }
    }
    .aw-4{
        .activity{
            padding-top: 25%;
            padding-bottom: 25%;
        }
    }
    .aw-5{
        .activity{
            padding-top: 20%;
            padding-bottom: 20%;
        }
    }


    .title{
        position: static;
        z-index: 1;
        padding: 1rem;

        h6{
            background: rgba(white, 0.7);
            padding: 0.5rem;
            display: inline-block;
            border-radius: 0.3rem;
            color: $dark;
            backdrop-filter: blur(3px);
        }
    }
}

.sortable-ghost{
    .activity{
        background: rgba($dark, 0.3);
        border-color: $dark;
        > * {
            opacity: 0.5;
        }
    }
}
.info{
    position: absolute;
    background: $primary;
    color: white;
    bottom: 0;
    left: 0;
    border-radius: 0 0.4rem 0 0.4rem;
    padding: 0.2rem 0.5rem;
    text-transform: uppercase;
}

.preview-image{
    height: 75vh;
    object-fit: contain;
}

iframe{
    width: 100%;
    height: 75vh;
}

.text{
    height: 75vh;
    overflow: auto;
}

</style>
